import { render, staticRenderFns } from "./frontendPackagesPaypal.vue?vue&type=template&id=ab661752&scoped=true&"
import script from "./frontendPackagesPaypal.vue?vue&type=script&lang=js&"
export * from "./frontendPackagesPaypal.vue?vue&type=script&lang=js&"
import style0 from "./frontendPackagesPaypal.vue?vue&type=style&index=0&id=ab661752&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab661752",
  null
  
)

export default component.exports